var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-app",class:{
    'c-app-obtrusive-scrollbars': _vm.obtrusiveScrollbars
  }},[_c('crt-frame',{staticClass:"c-app-screen"},[_c('slow-channel-change',[_c('router-view',{key:_vm.routeKey})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }